import { ELiveChartsPeriod, EUnit, WeightUnitType } from '@core/type';

export const CHART_UNIT_DEFAULT: WeightUnitType = EUnit.GRAM;
export const CHART_PERIOD_DEFAULT: ELiveChartsPeriod = ELiveChartsPeriod.DAY;
